import { service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class RecommendationStrategyAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  baseUrl = `${this.host}/apigateway/v1/app/pricing-assistant/recommendations/strategies/`;

  // @ts-expect-error: Property 'buildURL' in type 'RecommendationStrategyAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: unknown,
    requestType: string,
  ) {
    if (requestType === 'createRecord') {
      return this.urlForCreateRecord();
    }

    if (requestType === 'updateRecord') {
      return this.urlForUpdateRecord(id);
    }

    if (requestType === 'deleteRecord') {
      return this.urlForDeleteRecord(id);
    }

    return this.baseUrl;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForCreateRecord() {
    const hotelId = this.hotelAndMarketService.hotel.id;
    return `${this.baseUrl}?subscription_id=${hotelId}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForDeleteRecord(id: string) {
    const hotelId = this.hotelAndMarketService.hotel.id;
    return `${this.baseUrl}${id}/?subscription_id=${hotelId}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForUpdateRecord(id: string) {
    const hotelId = this.hotelAndMarketService.hotel.id;
    return `${this.baseUrl}${id}?subscription_id=${hotelId}`;
  }
}
